import { EmploymentType } from '@nkr/enums/index';

export const normalizeEmploymentType = (employmentType: string | number | undefined): EmploymentType | undefined => {
    if (employmentType === undefined || employmentType === null) {
        return undefined;
    }

    if (typeof employmentType === 'number') {
        switch (employmentType) {
            case 1:
                return EmploymentType.HOURLY;
            case 2:
                return EmploymentType.SALARIED;
            case 3:
                return EmploymentType.SELF_EMPLOYED;
            default:
                return undefined;
        }
    }

    if (typeof employmentType === 'string') {
        const normalized = employmentType.toUpperCase().trim().replace(/-/g, '_');
        
        if (normalized === '1' || normalized === EmploymentType.HOURLY) {
            return EmploymentType.HOURLY;
        }
        if (normalized === '2' || normalized === EmploymentType.SALARIED) {
            return EmploymentType.SALARIED;
        }
        if (normalized === '3' || normalized === EmploymentType.SELF_EMPLOYED) {
            return EmploymentType.SELF_EMPLOYED;
        }
    }

    return undefined;
};

export const isSelfEmployed = (employmentType: string | number | undefined): boolean => {
    const normalized = normalizeEmploymentType(employmentType);
    return normalized === EmploymentType.SELF_EMPLOYED;
};

export const isHourly = (employmentType: string | number | undefined): boolean => {
    const normalized = normalizeEmploymentType(employmentType);
    return normalized === EmploymentType.HOURLY;
};

export const isSalaried = (employmentType: string | number | undefined): boolean => {
    const normalized = normalizeEmploymentType(employmentType);
    return normalized === EmploymentType.SALARIED;
};

